import styled from 'styled-components'
import { Alert } from '@mui/material'

interface Props {
  children: JSX.Element | string
  className?: string
}

export default function ErrorMessage({ children, className }: Props): JSX.Element {
  return (
    <AlertMessage severity="error" className={className}>
      {children}
    </AlertMessage>
  )
}

const AlertMessage = styled(Alert)`
  background-color: rgba(255, 11, 24, 0.67);
  color: ${(props) => props.theme.customPalette.light};

  & .MuiAlert-icon {
    color: ${(props) => props.theme.customPalette.light};
  }
`
